import React, {
  createContext,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import { reducer } from './reducer';


export const BrandKitContext = createContext(null);
export const useBrandKitContext = () => useContext(BrandKitContext);

export function BrandKitProvider({
  children,
}) {
  const [state, dispatch] = React.useReducer(reducer, {
  });
  const context = {
    state,
    dispatch,
  };
  return (
    <BrandKitContext.Provider value={context}>
      {children}
    </BrandKitContext.Provider>
  );
}

BrandKitProvider.displayName = 'BrandKitProvider';
BrandKitProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


export function withBrandKitContext(Component) {
  return props => (
    <BrandKitProvider>
      <Component {...props} />
    </BrandKitProvider>
  );
}
